import { Can, usePermissions } from "context/permissionContenxt";
import HangfireDashboard from "pages/Admin/Hangfire";
import Impersonation from "pages/Admin/Impersonation";
import LogViewer from "pages/Admin/LogViewer";
import Clearings from "pages/govnr/Clearings";
import Dashboard from "pages/govnr/Dashboard";
import ProgramSettings from "pages/govnr/ProgramSettings";
import UserSettings from "pages/govnr/UserSettings";
import PanelladikesApplicationDetails from "pages/PaneladikesApplicationDetails";
import UsersPage from "pages/Users";
import { Navigate } from "react-router-dom";
import { LookupProvider } from "src/context/lookupContext";
import MainLayout from "src/layout/MainLayout";
import ApplicationDetails from "src/pages/ApplicationDetails";
import Applications from "src/pages/Applications";
import ApplicationsExplorer from "src/pages/govnr/Applications";
import WhitelistExplorer from "src/pages/govnr/Whitelist";
import PageNotFound from "src/pages/PageNotFound";

// const HomeNavigation = () => {
//   return (
//     <>
//       <Can I="View" a="Applications">
//         <Navigate to="applications" />
//       </Can>
//       <Can I="View" a="GovnrApplications">
//         <Navigate to="govnr/applications" />
//       </Can>
//     </>
//   );
// };

const ApplicationsNavigation = () => {
  return (
    <>
      <Can I="View" a="Applications">
        <Navigate to="/applications" replace />
      </Can>
      <Can I="View" a="GovnrApplications">
        <Navigate to="/govnr/applications" replace />
      </Can>
    </>
  );
};

const HomeNavigation = () => {
  return (
    <>
      <Can I="View" a="Applications">
        <Navigate to="/applications" replace />
      </Can>
      <Can I="View" a="GovnrApplications">
        <Navigate to="/govnr/applications" replace />
      </Can>
      <Can I="View" a="Dashboard">
        <Navigate to="/govnr/dashboard" replace />
      </Can>

    </>
  );
};

const PermissionWrapper = (props) => {
  const prm = usePermissions();
  const { action, subject, children } = props;
  if (prm.can(action, subject)) return <>{children}</>;
  return <PageNotFound />;
};

const MainRoutes = () => {
  return [
    {
      path: "",
      element: <MainLayout />,
      children: [
        { path: "home", element: <Navigate to="/" /> },
        {
          path: "applications",
          element: (
            <PermissionWrapper action="View" subject="Applications">
              <Applications />
            </PermissionWrapper>
          ),
        },
        {
          path: "govnr/applications",
          element: (
            <PermissionWrapper action="View" subject="GovnrApplications">
              <ApplicationsExplorer />
            </PermissionWrapper>
          ),
        },
        {
          path: "application/:id",
          element: (
            <LookupProvider>
              <ApplicationDetails />
            </LookupProvider>
          ),
        },
        {
          path: "student-application/:id",
          element: (
            <LookupProvider>
              <PanelladikesApplicationDetails />
            </LookupProvider>
          ),
        },
        {
          path: "govnr/whitelist",
          element: (
            <PermissionWrapper action="View" subject="Whitelist">
              <WhitelistExplorer />
            </PermissionWrapper>
          ),
        },
        {
          path: "admin/hangfire",
          element: (
            <PermissionWrapper action="View" subject="HangfireDashboard">
              <HangfireDashboard />
            </PermissionWrapper>
          ),
        },
        {
          path: "admin/log-viewer",
          element: (
            <PermissionWrapper action="View" subject="LogViewer">
              <LogViewer />
            </PermissionWrapper>
          ),
        },
        {
          path: "admin/impersonation",
          element: (
            <PermissionWrapper action="View" subject="Impersonation">
              <Impersonation />
            </PermissionWrapper>
          ),
        },
        {
          path: "govnr/clearings",
          element: (
            <PermissionWrapper action="View" subject="Clearings">
              <Clearings />
            </PermissionWrapper>
          ),
        },
        {
          path: "govnr/program-settings",
          element: (
            <PermissionWrapper action="View" subject="ProgramSettings">
              <ProgramSettings />
            </PermissionWrapper>
          ),
        },
        {
          path: "govnr/dashboard",
          element: (
            <PermissionWrapper action="View" subject="Dashboard">
              <Dashboard />
            </PermissionWrapper>
          ),
        },
        { path: "applications-navigate", element: <ApplicationsNavigation /> },
        { path: "govnr/users", element: <UsersPage /> },
        { path: "govnr/user-settings", element: <UserSettings /> },

        { path: "", element: <HomeNavigation /> },
        {
          path: "*",
          element: <PageNotFound />,
        },
      ],
    },
  ];
};

export default MainRoutes;
